<form *ngIf="form" [formGroup]="form" (ngSubmit)="submit()">
	<bp-alert type="danger" [errors]="errors"> </bp-alert>

	<bp-otp-provider-message [resourceName]="resourceName"></bp-otp-provider-message>

	<bp-otp-code-input class="w-100 mt-3" formControlName="code" required></bp-otp-code-input>
</form>
